export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const SET_APP_MODE = 'SET_APP_MODE';
export const SET_APP_MODULE = 'SET_APP_MODULE';
export const SET_MOBILE = 'SET_MOBILE';
export const SET_COMMON_SOUNDS = 'SET_COMMON_SOUNDS';
export const API_ERROR = 'API_ERROR';
export const SHOW_FORWARD_BUTTON = 'SHOW_FORWARD_BUTTON';
export const HIDE_FORWARD_BUTTON = 'HIDE_FORWARD_BUTTON';
export const SET_PULSE_TIMESTAMP = 'SET_PULSE_TIMESTAMP';
export const SET_MIC_PERMISSIONS = 'SET_MIC_PERMISSIONS';
export const SHOW_VISUAL_CUE = 'SHOW_VISUAL_CUE';
export const HIDE_VISUAL_CUE = 'HIDE_VISUAL_CUE';

export const CLEAR_LOGIN_SOUNDS = 'CLEAR_LOGIN_SOUNDS';
export const CLEAR_COMMON_SOUNDS = 'CLEAR_COMMON_SOUNDS';

export const SET_ACTIVITY_TIMESTAMP = 'SET_ACTIVITY_TIMESTAMP';
export const SET_LITE_VERSION = 'SET_LITE_VERSION';
export const SET_ACCESSIBILITY_MODE = 'SET_ACCESSIBILITY_MODE';
